"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../../../configuration/utils");

var _FavoriteIconComponent = _interopRequireDefault(require("../../../PEP-favorite-product/js/FavoriteIconComponent"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _constans = require("../../../../configuration/constans");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SliderComponent = function SliderComponent() {
  var _window;

  var images = (0, _reactRedux.useSelector)(function (state) {
    return state.currentSliderImg;
  });
  var defultImages = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct.images;
  });
  var product = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct;
  });
  var dictionary = (0, _reactRedux.useSelector)(function (state) {
    return state.dictionary;
  });
  var isMobile = (0, _reactRedux.useSelector)(function (state) {
    return state.isMobile;
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      nav1 = _useState2[0],
      setNav1 = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      nav2 = _useState4[0],
      setNav2 = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      sliderImages = _useState6[0],
      setSliderImages = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      sliderIndex = _useState8[0],
      setSliderIndex = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      openImageLayer = _useState10[0],
      setImageLayer = _useState10[1];

  var accessoryParametr = (0, _reactRedux.useSelector)(function (state) {
    return state.accessoryParametr;
  });
  var isAccessory = ((_window = window) === null || _window === void 0 ? void 0 : _window.location.href.indexOf(accessoryParametr)) > -1;
  var productInfo = !isAccessory ? "".concat(product.title, " ").concat(product.subtitle || '') : product.title;
  (0, _react.useEffect)(function () {
    //to reset slider when changing
    var randomCounter = Math.random() * 10;
    setSliderIndex(randomCounter);

    if ((images === null || images === void 0 ? void 0 : images.length) > 0) {
      var imagesExceptLifestyle = images.filter(function (img) {
        return !(0, _utils.checkIfLifestyleImg)((img === null || img === void 0 ? void 0 : img.cdnUrl) || '');
      });
      setSliderImages(imagesExceptLifestyle);
    } else {
      var _imagesExceptLifestyle = defultImages.filter(function (img) {
        return !(0, _utils.checkIfLifestyleImg)((img === null || img === void 0 ? void 0 : img.cdnUrl) || '');
      });

      setSliderImages(_imagesExceptLifestyle);
    }
  }, [images, product, defultImages]);

  var toggleLayer = function toggleLayer() {
    if (!isMobile) {
      (0, _utils.toggleLayerFunction)(!openImageLayer);
      (0, _utils.sendDataLayerEvent)('Image carousel section', "".concat(productInfo, " > ").concat(openImageLayer ? 'closed' : 'expanded'));
      setImageLayer(openImageLayer ? false : true);
      setSliderIndex(sliderIndex);
    }
  };

  var mainSliderSettings = {
    dots: false,
    speed: 400,
    slidesToShow: 1,
    swipeToSlide: false,
    adaptiveHeight: false,
    arrows: false,
    lazyLoad: 'ondemand',
    ref: function ref(slider) {
      return setNav1(slider);
    },
    asNavFor: nav2,
    initialSlide: 0,
    responsive: [{
      breakpoint: 991,
      settings: {
        dots: true,
        lazyLoad: 'ondemand',
        arrows: false,
        adaptiveHeight: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        asNavFor: false,
        ref: false
      }
    }]
  };
  var navSliderSettings = {
    // slidesToShow: images && images.length % 3 ? 6 : 7,
    slidesToScroll: 1,
    speed: 300,
    focusOnSelect: true,
    accessibility: true,
    infinite: false,
    swipeToSlide: false,
    asNavFor: nav1,
    ref: function ref(slider) {
      return setNav2(slider);
    },
    centerMode: false,
    variableWidth: true,
    initialSlide: 0,
    beforeChange: function beforeChange() {
      (0, _utils.sendDataLayerEvent)('Image carousel change', "".concat(productInfo));
    },
    responsive: [{
      breakpoint: 991,
      settings: {
        slidesToShow: openImageLayer ? 0 : 5,
        asNavFor: false,
        ref: false,
        sliderToShow: 1,
        dots: true
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: openImageLayer ? 0 : 4
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: openImageLayer ? 0 : 3
      }
    }]
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, sliderImages && sliderIndex && /*#__PURE__*/_react["default"].createElement("div", {
    className: openImageLayer ? 'image-zoom-layer carousel animated fade-in' : 'carousel animated'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "carousel-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: openImageLayer ? 'main-slide' : 'main-slide animated fade-in'
  }, /*#__PURE__*/_react["default"].createElement(_FavoriteIconComponent["default"], {
    product: product,
    dictionary: dictionary
  }), /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], _extends({
    key: sliderIndex
  }, mainSliderSettings), sliderImages.map(function (img, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "img-wrapper",
      key: sliderIndex + index
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: (0, _utils.resolveImage)(img, _constans.fastlyCompressionQuery.mainSlider),
      onClick: toggleLayer,
      alt: "".concat(img.filename || '', "  ").concat(product.title || ''),
      height: "500",
      width: "auto"
    }));
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "zoom-icon",
    dangerouslySetInnerHTML: {
      __html: '&#x' + dictionary.icons.searchIcon + ';'
    },
    onClick: toggleLayer
  }), openImageLayer && /*#__PURE__*/_react["default"].createElement("div", {
    className: "close-layer-button",
    onClick: toggleLayer
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "nav-slider"
  }, !isMobile && /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], _extends({
    key: sliderIndex
  }, navSliderSettings), sliderImages.map(function (img, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "img-wrapper",
      key: index
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: (0, _utils.resolveThumbnailImage)(img, _constans.fastlyCompressionQuery.thumbnailsSlider),
      alt: product.title,
      height: "320",
      width: "320"
    }));
  }))))));
};

var _default = SliderComponent;
exports["default"] = _default;